import * as React from 'react';
import { GetStaticProps } from 'next';

import { getServerTranslations } from '../../get-server-side-translations';
import { GettingStartedPage } from '../../components/organization-onboarding/getting-started-page';

const BASE_URL = process.env.VERCEL_URL || '';

const OG = {
  title: "Crea un'offerta di lavoro su Restworld",
  description:
    'Pubblica un annuncio in 3 minuti. Noi contattiamo, intervistiamo e filtriamo i candidati per te. Sospendi quando vuoi.',
  image: `${BASE_URL}/utils-assets/og-getting-started-generic.png`,
  canonicalUrl: `${BASE_URL}/getting-started`,
};

const NewEmployersPage: React.FunctionComponent = () => <GettingStartedPage og={OG} />;

export default NewEmployersPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await getServerTranslations(locale, [
    'common',
    'jp-onboarding',
    'restaurant-onboarding',
    'job-positions-page',
    'job-position-page',
    'payment-and-invoices',
  ]);
  return {
    props: {
      ...translation,
    },
  };
};
